export default __webpack_public_path__ + "static/media/unionWifi.ba5ccc14.png";